import { GetterTree } from 'vuex'
import { GroupsApplicationsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<GroupsApplicationsState, RootState> = {
  groupsApplications: state => state.groupsApplications,
};
